import Harvest from './Harvest';

export default Harvest;
